import { render, staticRenderFns } from "./AddServiceCategory.vue?vue&type=template&id=acc1b810&scoped=true&"
import script from "./AddServiceCategory.vue?vue&type=script&lang=js&"
export * from "./AddServiceCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceCategory.vue?vue&type=style&index=0&id=acc1b810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc1b810",
  null
  
)

export default component.exports